import { QueryParams } from "@/models/query-params.model";
import api from "@/services/api-config/rxjs-config";
import { Observable } from "rxjs";

export class CourseStudentRest {
  getCoursesByUserId(userId: string, params: QueryParams): Observable<any> {
    const url: string = `/users/${userId}/courses`;
    return api.get(url, params);
  }

  getCourseById(
    userId: string,
    courseId: string,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url = `/users/${userId}/courses/${courseId}`;
    return api.get(url, params);
  }

  getCourseByIdGraphs(
    userId: string,
    courseId: string,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `/course-state/${courseId}/${userId}`;
    return api.get(url, params, "/graphs");
  }

  getChaptersByCourse(
    courseId: string,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `/courses/${courseId}/chapters`;
    return api.get(url, params, "/graphs");
  }

  getTrailsByChapter(
    courseId: string,
    chapterId: string,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `third-party/course-student/${courseId}/chapters/${chapterId}/trails`;
    return api.get(url, params, "/graphs");
  }

  getMaterialById(
    learningObjectivesId: string,
    materialId: string,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `/learning-objectives/${learningObjectivesId}/materials/${materialId}`;
    return api.get(url, params, "/graphs");
  }

  getGraphsByCourse(
    courseId: string,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `/courses/${courseId}/graphs`;
    return api.get(url, params, "/graphs");
  }

  getCertificate(
    courseId: string,
    userId: string,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `/course-student/${courseId}/${userId}/certificate`;
    return api.get(url, params, "/api", "blob");
  }

  getLearningMapStudent(
    courseId: string,
    userId: string,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `/course-state/${courseId}/${userId}/completed`;
    return api.get(url, params, "/graphs");
  }

  getTraditionalCourseById(
    courseId: string,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `/third-party/course-student/${courseId}`;
    return api.get(url, params, "/graphs");
  }

  getMaterialsByTrail(
    trailId: string,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `/trails/${trailId}/materials`;
    return api.get(url, params, "/graphs");
  }

  getAllMaterialsByTrail(
    courseId: string,
    trailId: string,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `third-party/course-student/${courseId}/chapters/trails/${trailId}/materials`;
    return api.get(url, params, "/graphs");
  }

  getMaterialsByLearningObjective(
    learningObjectivesId: string,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `/learning-objectives/${learningObjectivesId}/materials`;
    return api.get(url, params, "/graphs");
  }
}
